// --- Vendors ---
import Isotope from 'isotope-layout';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import GLightbox from 'glightbox';

// --- Components ---
const home = {
    readyFn: function () {
        jQueryBridget('masonry', Masonry, $);
        jQueryBridget('isotope', Isotope, $);

        console.log("Home");

        const lightbox = GLightbox({
            loop: true,
        });

        // Initialisation de l'Isotope
        var $gridActivite = $('.grid-image').isotope({
            itemSelector: '.grid-item',
        });

        // Gestion du filtre sur les tags
        $(".tag-list .tag").on("click", function () {
            var $this = $(this); // Référence à l'élément cliqué

            // Vérifie si l'élément cliqué est le bouton "Tous"
            if ($this.hasClass("all")) {
                $(".tag-list .tag").removeClass("actif");
                $gridActivite.isotope({
                    filter: '' // Réinitialisation du filtre pour afficher tous les éléments
                });
                $(this).addClass("actif");
            } else {
                // Gère l'ajout et la suppression de la classe "actif" pour le tag cliqué
                $(".tag.all").removeClass("actif");
                $this.toggleClass("actif");

                // Récupère les valeurs des filtres actifs
                var filterValue = $(".tag-list .tag.actif").map(function () {
                    return $(this).attr("data-filter");
                }).get().join('');

                // Si aucun filtre n'est actif, rétablit l'état actif sur le tag "Tous"
                if (!filterValue) {
                    $(".tag.all").addClass("actif");
                }

                // Applique le filtre Isotope
                $gridActivite.isotope({
                    filter: filterValue
                });

                // Debug pour voir les filtres appliqués
                console.log("filterValues : " + filterValue);
            }
        });


        $("#filtre-activite").on("change", function () {
            var filterValue = $(this).val();
            $gridActivite.isotope({
                filter: filterValue
            });
        });

    }
}
export { home };